import AiAuthContainer from './AiAuthContainer';

const AiAuth = () => {
    return (
        <div className="flex flex-wrap min-h-screen">
            <div className='w-full md:w-6/12 flex flex-col md:px-5 md:py-10 z-10'>
                <div className='flex flex-wrap px-4 md:px-0'>
                    <img src={'/assets/admin/header-icon.svg'} className='object-contain h-[45px] mb-5 ml-5' />
                </div>
                <AiAuthContainer />
            </div>
            <div className="hidden md:block md:w-6/12 md:sticky md:top-0 md:h-screen p-2">
                <div className="h-full">
                    <img
                        alt="Login"
                        className="w-full h-full object-cover"
                        src="/assets/admin/signin-color-img.svg"
                    />
                </div>
            </div>
        </div>
    );
};

export default AiAuth;
